import { IconBrandChrome, IconBrandEdge, IconBrandFirefox, IconChevronDown } from '@tabler/icons';
import { m } from 'framer-motion';
import { useState } from 'preact/hooks';

import * as urls from '../../urls';

function DownloadMenu() {
  const [isOpen, setOpen] = useState(false);

  return (
    <div class="relative inline-block">
      <button onClick={() => setOpen(x => !x)} class="font-semibold bg-white text-purple-600 px-4 py-2 border-2 border-purple-300 rounded shadow inline-flex items-center focus:outline-none select-none">
        Select your browser
        <m.span className="ml-1 inline-block" initial={{ rotate: 0 }} animate={{ rotate: isOpen ? 180 : 0 }}>
          <IconChevronDown size={20} />
        </m.span>
      </button>
      <m.div className="absolute top-full -mt-0.5 left-0 right-0 text-left" animate={{ opacity: isOpen ? 1 : 0, visibility: isOpen ? 'visible' : 'hidden' }} transition={{ duration: 0.2 }}>
        <ul class="bg-white px-2 py-2 rounded shadow-md border-2 border-purple-300">
          <li>
            <a href={urls.CHROME_WEB_STORE}  class="font-semibold inline-flex items-center w-full py-2 px-2 transition-colors hover:bg-purple-50 hover:text-purple-600 rounded-sm">
              <IconBrandChrome className="inline-block mr-2" size={20} />
              Chrome
            </a>
          </li>
          <li>
            <a href={urls.FIREFOX_ADDON}  class="font-semibold inline-flex items-center w-full py-2 px-2 transition-colors hover:bg-purple-50 hover:text-purple-600 rounded-sm">
              <IconBrandFirefox className="inline-block mr-2" size={20} />
              Firefox
            </a>
          </li>
          <li>
            <a href={urls.EDGE_ADDON}  class="font-semibold inline-flex items-center w-full py-2 px-2 transition-colors hover:bg-purple-50 hover:text-purple-600 rounded-sm">
              <IconBrandEdge className="inline-block mr-2" size={20} />
              Edge
            </a>
          </li>
        </ul>
      </m.div>
    </div>
  );
}

export default DownloadMenu;
